// extracted by mini-css-extract-plugin
export default {"option":"ProvisionSelectOption-module__option--NNHRC","badge":"ProvisionSelectOption-module__badge--phBnB"};